module.exports = __webpack_public_path__ + "img/topic_communication.e8e62a61.svg";